/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const TaskPage = lazyLoad(
  () => import('./index'),
  module => module.TaskPage
);
